import {useCallback} from 'react'
import {gql, useMutation} from '@apollo/client'
import myUniversity from './queryResults/myUniversity'

export default (onSuccess, onError = () => {}) => {
  const [mutation, {data, error, loading}] = useMutation(
    gql`
        mutation(
              $userId: ID
              $universityId: ID!
              $charge: Boolean
              $planId: ID
              ){
                  setMyUniversity (
                    universityId: $universityId
                    userId: $userId
                    charge: $charge
                    planId: $planId
                  ){
                    ${myUniversity} 
                  }
              }
      `,
  )
  const submit = useCallback(
    (obj) => {
      mutation({variables: obj})
        .then((result) => {
          onSuccess(result)
        })
        .catch((e) => {
          onError(e)
        })
    },
    [mutation, onSuccess, onError],
  )
  return {loading, data: data ? data.setMyUniversity : null, error, submit}
}
